<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<tree ref="tree0" :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
						<el-tab-pane :label="this.$t('label_161')" name="second">
							<tree ref="tree1" :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" style="height: 95%;" v-if="getTreeMes=='1'">
						<p class="title"><span class="spot">{{deviceDetailMes.name != null ? '<' + deviceDetailMes.name + '>' : '<' + $t('label_272') + '>'}}</span>{{$t('label_697')}}</p>
						<div class="chooseBox6" style="position: relative; width: 100%">
              <div class="selectBox">
                <div class="selectChoose" style="width: 330px;">
                  <div class="selectText" style="width: 145px;">
                    <p>{{$t('label_296')}}</p>
                  </div>
                  <div class="select" style="width:330px">
                    <el-date-picker
                      v-model="Readytime" type="daterange" format="yyyy-MM-dd" value-format='yyyy-MM-dd'
                      :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
                    </el-date-picker>
                  </div>
                </div>
                <div class="selectChoose" style="width: 330px">
                  <div class="selectText" style="width: 145px">
                    <p>{{$t('label_521')}}</p>
                  </div>
                  <div class="select" style="width:330px">
                    <el-select v-model="faultLevel" :placeholder="$t('input_75')">
                      <el-option v-for="item in faultLevel2" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="selectChoose" style="width: 330px">
                  <div class="selectText" style="width: 145px">
                    <p>{{$t('label_41')}}</p>
                  </div>
                  <div class="select" style="width:330px">
                    <el-input v-model="orderNo" clearable></el-input>
                  </div>
                </div>
              </div>
              <div style="margin-left: 20px">
                <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i
                  class="el-icon-search"></i>{{$t('btn_2')}}
                </div>
              </div>
						</div>
						<!-- <div class="spotStatusNumList">
							<div class="statusMesBox" v-for="(item,index) in spotStatusNumList" :class="item.check==true?'check':''">
								<div class="iconBox" :style="{'background':item.color}"><i :class="item.icon"></i></div>
								<div class="textBox">
									<p>{{item.text}}</p>
									<p class="num" :style="{'color':item.color}">{{item.num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="item.check"></el-checkbox>
								</div>
							</div>
						</div> -->
						<div class="spotStatusNumList spotStatusNumListSmall">
							<!-- <div class="statusMesBox" v-for="(item,index) in spotStatusNumList" :class="item.check==true?'check':''"> -->
							<div class="statusMesBox">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_272')}}</p>
									<p class="num" style="color:#000000">{{spotStatusNumList[0].num}}</p>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[1].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_299')}}</p>
									<p class="num" style="color:#e60000">{{spotStatusNumList[1].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[1].check"></el-checkbox>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[2].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_303')}}</p>
									<p class="num" style="color:#e60000">{{spotStatusNumList[2].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[2].check"></el-checkbox>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[3].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_307')}}</p>
									<p class="num" style="color:#e60000">{{spotStatusNumList[3].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[3].check"></el-checkbox>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[4].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_311')}}</p>
									<p class="num" style="color:#ffb400">{{spotStatusNumList[4].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[4].check"></el-checkbox>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[5].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_314')}}</p>
									<p class="num" style="color:#e60000">{{spotStatusNumList[5].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[5].check"></el-checkbox>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[6].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_318')}}</p>
									<p class="num" style="color:#ffb400">{{spotStatusNumList[6].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[6].check"></el-checkbox>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[7].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_829')}}</p>
									<p class="num" style="color:#3fb393">{{spotStatusNumList[7].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[7].check"></el-checkbox>
								</div>
							</div>
							<div class="statusMesBox" :class="spotStatusNumList[8].check==true?'check':''">
								<div class="textBox">
									<p style="height: 48px;">{{$t('label_326')}}</p>
									<p class="num" style="color:#aeaeae">{{spotStatusNumList[8].num}}</p>
								</div>
								<div class="checkBox">
									<el-checkbox label="" v-model="spotStatusNumList[8].check"></el-checkbox>
								</div>
							</div>
						</div>
						<div class="spotMes2Box" style="height: calc(100% - 250px)">
							<div class="buttonBox" style="justify-content: space-between">
								<div>
									<div class="chooseButton searchButton" @click="results">{{$t('btn_52')}}</div>
									<div class="chooseButton searchButton" @click="exportExcel"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>
								</div>
								<div v-if="0" style="display: flex;justify-content: space-between">
									<template v-for="item in guzhangList">
										<div class="circleStyle" :style="{'background':item.colorShow}">
										</div>
										<p style="margin:5px 10px 0px 10px;">{{item.val}}</p>
									</template>
								</div>
							</div>
							<div class="tableMin" style="height: 90%;">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTreeTime"
								 border style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
								 height="88%" @row-click="handler">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="orderNo" :label="$t('label_45')" align="center" width="200">
										<template slot-scope="scope">
											<p :style="{'color':spotStatusNumList[scope.row.status].color}">{{spotStatusNumList[scope.row.status].text}}</p>
											<template v-if="scope.row.faultLevel!=''&&scope.row.faultLevel!=null">
												<template v-for="item in guzhangList">
													<p style="font-weight: bold;" v-if="scope.row.faultLevel==item.val" :style="{'color':item.val==scope.row.faultLevel?item.colorShow:'#000000'}">{{scope.row.orderNo}}</p>
												</template>
											</template>
											<template v-if="scope.row.faultLevel==''||scope.row.faultLevel==null">
												<p style="font-weight: bold;">{{scope.row.orderNo}}</p>
											</template>
										</template>
									</el-table-column>
									<el-table-column prop="superior" :label="$t('label_593')" align="left" width="300px">
										<template slot-scope="scope">
											{{scope.row.superior}}<br>
											{{scope.row.tname}} {{scope.row.ename}}<br>
											{{scope.row.code}}
										</template>
									</el-table-column>
									<el-table-column prop="faultPhenomenon" :label="$t('label_348')" align="left">
										<template slot-scope="scope">
											{{scope.row.faultPhenomenon}}<br>
											{{scope.row.faultExplain}}
										</template>
									</el-table-column>
									<el-table-column prop="reportPerson" :label="$t('label_50')" align="center">
										<template slot-scope="scope">
											<p>{{scope.row.reportPerson}}</p>
											<p>{{scope.row.reportTime}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="repairman" :label="$t('label_54')" align="center">
										<template slot-scope="scope">
											<p>{{scope.row.repairman}}</p>
											<p>{{scope.row.repairBeginTime}}</p>
										</template>
									</el-table-column>
								</el-table>
								<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
								 @parentMethod="search"></Page>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<el-dialog :title="$t('btn_52')" :visible.sync="dialogSpotResult" append-to-body :close-on-click-modal='false' width="1600px"
		 v-dialogDrag top="1%" :before-close="handleClose" custom-class="dialogBox" class="bbb">
			<div class="dialogBoxMes" style="padding:0 ;">
				<div class="titleMes1" style="justify-content: space-between;">
					<div style="display: flex;">
					</div>
				</div>
				<div class="titleMes1" style="margin-top: 10px">
					<p style="line-height: 40px"><span style="color: #ff0000">*</span>{{$t('label_593')}}</p>
					<div style="margin-left: 5px;width:305px">
						<!-- <el-autocomplete style="width:100%" v-model="mainEditList.devicName" :fetch-suggestions="querySearchAsync1"
						 placeholder="请输入设备名称" :trigger-on-focus="false" @select="handleSelect4" value-key="name" clearable @clear="clearSearch(4)"
						 ref="myAutocomplete4"><i slot="suffix" class="el-input__icon el-icon-search"></i>
						</el-autocomplete> -->
						<el-select v-model="mainEditList.devicName" @change="deviceChoose(mainEditList.devicName)" filterable :placeholder="$t('input_34')"
						 style="width: 100%;">
							<el-option v-for="item in this.deviceList" :key="item.id" :label="item.name" :value="`${item.id}&@${item.name}&@${item.superior}&@${item.deptId}&@${item.typeName}`">
							</el-option>
						</el-select>
					</div>
					<div style="margin-left: 20px;min-width: 200px; line-height: 40px;">
						<p>{{$t('label_429')}}: {{mainEditList.typeName}}</p>
					</div>
					<div style="margin-left: 10px; line-height: 40px; width: 700px;">
						<p>{{$t('label_161')}}: {{mainEditList.superior}}</p>
					</div>
					<div style="margin-left: 30px; width: 180px; line-height: 40px;">
						<p>{{allList.orderNo}}</p>
					</div>
				</div>
				<div class="titleMes1" style="justify-content: space-between;">
					<div style="display: flex;">
						<p style="line-height: 40px;"><span style="color: #ff0000">*</span>{{$t('label_348')}}</p>
						<div style="margin-left: 10px;height: 40px;line-height: 45px;display: flex;" class="otherInput">
							<el-checkbox-group v-model="mainEditList.faultPhenomenon">
								<div v-for="item in faultPhenomenonList" style="display: inline-flex;width: 140px;">
									<el-checkbox :label="item.val">{{item.val}}</el-checkbox>
								</div>
								<div style="display: inline-flex;width: 300px;">
									<el-checkbox :label="$t('label_380')">{{$t('label_380')}}
										<el-input style="width: 220px;" v-model="mainEditList.fault" :disabled="mainEditList.faultPhenomenon!=''?mainEditList.faultPhenomenon.toString().indexOf($t('label_380'))>=0?false:true:true"></el-input>
									</el-checkbox>
								</div>
							</el-checkbox-group>
							<div style="margin-left: 10px;">
								<el-popover placement="right" width="550" trigger="click" class="knowpop">
									<div v-if="mainEditList.equipmentId!=null&&mainEditList.equipmentId!=''">
										<div class="knowledge" style="width: 100%;height: 420px;">
											<div class="tableMes2Box" style="margin: 0px 0px 5px 5px;">
												<p style="margin-top: 5px; width: 80px;">{{$t('label_382')}}</p>
												<div style="width:calc(100% - 25px)">
													<el-input v-model="knowledgeSelect2.faultExplain" @change="selectknowledge3(1)"></el-input>
												</div>
											</div>
											<div style="width: 100%;height: 35px; padding-left: 5px;">
												<el-select v-model="knowledgeSelect2.faultReasonClassify" :placeholder="$t('input_65')" @change="selectknowledge3(0)"
												 style="width: calc(50% - 5px);">
													<el-option :key="$t('label_272')" :label="$t('label_272')" value=""></el-option>
													<el-option v-for="item in cause" :key="item.key" :label="item.val" :value="item.val">
													</el-option>
												</el-select>
												<el-select v-model="knowledgeSelect2.faultReason" :placeholder="$t('input_65')" @change="selectknowledge3(1)">
													<el-option :key="$t('label_272')" :label="$t('label_272')" value=""></el-option>
													<el-option v-for="item in causeList" :key="item.key" :label="item.val" :value="item.val">
													</el-option>
												</el-select>
											</div>
											<div :key="index" :label="item" v-for="(item,index) in knowledgeList2">
												<div class="knowledgeChild">
													<span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}{{$t('label_207')}}</span>
													<p style="margin: 10px">
														<!-- 维修时间:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}} -->
														{{$t('label_393')}}: {{item.aveTime}} {{$t('label_395')}}
													</p>
													<p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
													<p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
												</div>
											</div>
										</div>
									</div>
									<div v-else>
										{{$t('msg_5')}}
									</div>
									<i class="el-icon-question" slot="reference" @click="selectknowledge3(0)"></i>
								</el-popover>

							</div>
						</div>
					</div>
				</div>
				<div class="tableMes2" style="margin-top: 10px">
					<div class="tableMes2Box" style="width: 100%;">
						<p style="margin-top: 5px; width: 100px; "><span style="color: #ffffff">*</span>{{$t('label_406')}}</p>
						<div style="margin: 0px 0px 0px 5px;width:100%;">
							<el-input v-model="mainEditList.faultExplain" clearable :rows="2">
							</el-input>
						</div>
					</div>
				</div>
				<div class="proSpotMes aaa" style="margin-bottom: 0px;  padding: 10px 68px 20px 0;">
					<el-steps align-center :active="status.active" :simple="stepsSimple">
						<el-step :title="stepsSimple?$t('label_78'):''">
							<template slot="description">
								<div :class="['steps_div',status.active<1?'steps_div_0':'steps_div_1']">
									<div style="height: 38px;"><span class="steps_div_span1">{{$t('label_78')}}</span>：<span>{{status.active<1?'--':status.reportPerson}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active<1?'--':$t('label_299')}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<1?'--':status.reportTime}}</span>
									</div>
								</div>
							</template>
						</el-step>
						<el-step :title="stepsSimple?$t('label_415'):''">
							<template slot="description">
								<div :class="['steps_div',status.active<2?'steps_div_0':'steps_div_1']">
									<div><span class="steps_div_span1">{{$t('label_415')}}</span>：<span>{{status.active<2?'--':status.dispatcher}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active<2?'--':$t('label_303')}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<2?'--':status.dispatchTime}}</span>
									</div>
								</div>
							</template>
						</el-step>
						<el-step :title="stepsSimple?$t('label_424'):''">
							<template slot="description">
								<div :class="['steps_div',status.active<3?'steps_div_0':'steps_div_1']">
									<div><span class="steps_div_span1">{{$t('label_424')}}</span>：<span>{{status.active<3?'--':status.receivingPerson}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active<3?'--':$t('label_307')}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<3?'--':status.orderTime}}</span>
									</div>
								</div>
							</template>
						</el-step>
						<el-step :title="stepsSimple?$t('label_434'):''">
							<template slot="description">
								<div :class="['steps_div',status.active<4?'steps_div_0':'steps_div_1']">
									<div><span class="steps_div_span1">{{$t('label_434')}}</span>：<span>{{status.active<4?'--':status.repairman}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active<4?'--':$t('label_311')}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<4?'--':status.repairBeginTime}}</span>
									</div>
								</div>
							</template>
						</el-step>
						<el-step :title="stepsSimple?$t('label_444'):''">
							<template slot="description">
								<div :class="['steps_div',status.active<5?'steps_div_0':'steps_div_1']">
									<div><span class="steps_div_span1">{{$t('label_444')}}</span>：<span>{{status.active<5?'--':status.accepter}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active>=5?(status.active==5?$t('label_318'):$t('label_448')):$t('label_314')}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<5?'--':status.acceptBeginTime}}</span>
									</div>
								</div>
							</template>
						</el-step>
						<el-step :title="stepsSimple?$t('label_452'):''">
							<template slot="description">
								<div :class="['steps_div',status.active<6?'steps_div_0':'steps_div_1']">
									<div><span class="steps_div_span1">{{$t('label_452')}}</span>：<span>{{status.active<6?'--':status.repairman}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active<6?'--':$t('label_829')}}</span>
									</div>
									<div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<6?'--':status.acceptEndTime}}</span>
									</div>
								</div>
							</template>
						</el-step>
					</el-steps>
					<div :class="stepsSimple?'open':'close'" @click="stepsSimple = !stepsSimple">
						<div style="margin-left: 185px;">
							<div></div>
						</div>
					</div>
				</div>
				<div class="treeMes " style="height: 460px; padding: 0; ">
					<div class="spotMesBox">
						<el-tabs v-model="mainEditTree" @tab-click="handleClickTree" style="height: 450px;" class="repairClass">
							<el-tab-pane :label="$t('label_456')" name="project">
								<div v-if="quickData=='0'">
									<div class="tableMes2">
										<div class="tableMes2Box">
											<p style="margin-top: 5px;">{{$t('label_293')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-input :disabled="true" v-model="mainEditList.reportPerson">
												</el-input>
											</div>
										</div>
										<div class="tableMes2Box">
											<p style="margin-top: 5px;">{{$t('label_569')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-input :disabled="true" v-model="mainEditList.mobile"></el-input>
											</div>
										</div>
										<div class="tableMes2Box">
											<p style="margin-top: 5px;">{{$t('label_290')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-select style="width: 250px;" v-model="mainEditList.urgentLevel" :placeholder="$t('input_44')">
													<el-option v-for="item in urgentList" :key="item.key" :label="item.val" :value="item.key">
													</el-option>
												</el-select>
											</div>
										</div>
										<div class="tableMes2Box" style="width: 400px;">
											<p style="margin-top: 5px;width: 130px;text-align-last: end;">{{$t('label_465')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-select style="width: 250px;" v-model="mainEditList.faultSource" :placeholder="$t('input_45')">
													<el-option v-for="item in faultList" :key="item.key" :label="item.val" :value="item.key">
													</el-option>
												</el-select>
											</div>
										</div>
									</div>
									<div class="tableMes2">
										<div class="tableMes2Box" style="width: 360px;">
											<p style="margin-top: 5px;width: 200px;">{{$t('label_467')}}</p>
											<div style="margin: 0px 18px 0px 5px;width:180px">
												<el-radio-group v-model="mainEditList.stop" @change="stopChange">
													<el-radio-button label="1">{{$t('label_471')}}</el-radio-button>
													<el-radio-button label="0">{{$t('label_474')}}</el-radio-button>
												</el-radio-group>
											</div>
										</div>
										<div class="tableMes2Box">
											<p style="margin-top: 5px;">{{$t('label_476')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-date-picker style="width: 250px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="mainEditList.stopTime"
												 type="datetime" :placeholder="$t('input_87')" :disabled="mainEditList.stop==0">
												</el-date-picker>
											</div>
										</div>
										<div class="tableMes2Box">
											<p style="margin-top: 5px;">{{$t('label_296')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-date-picker style="width: 250px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="mainEditList.reportTime"
												 type="datetime" :placeholder="$t('input_65')">
												</el-date-picker>
											</div>
										</div>
										<div class="tableMes2Box">
											<p style="margin-top: 5px;">{{$t('label_187')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-date-picker style="width: 250px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="mainEditList.expectTime"
												 type="datetime" :placeholder="$t('input_90')">
												</el-date-picker>
											</div>
										</div>
									</div>

									<div class="tableMes2">
										<p style="margin-top: 5px;">{{$t('label_484')}}</p>
										<!-- <div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;">
											<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :file-list="fileList"
											 :http-request="upload" :show-file-list="false">
												<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
											</el-upload>
										</div> -->
										<!-- <div v-for="(item,index) in mainEditList.faultImg" style="width: 50px;height: 50px;margin-left: 30px;position: relative;">
											<img style="width: 50px;height: 50px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item" @click="showImg(item)">
											<i v-if="allList.orderNo==''" class="el-icon-close" style="position:absolute;top:0px;right:-20px;color: #000000; cursor:pointer"
											 @click="removeFaultImg(index)"></i>
										</div> -->
										<div v-for="(item,index) in mainEditList.faultImg" class="photoNewdiv">
											<img v-if="showIcon(item)" class="imgstyle" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
											 @click="previewPdf(item)">
											<img v-if="!showIcon(item)" class="imgstyle" src="../../../static/img/fileText.png" @click="previewPdf(item)">
											<el-tooltip class="item" effect="dark" :content="showName(item)" placement="bottom-start">
												<span class="fileName">{{showName(item)}}</span>
											</el-tooltip>
										</div>
									</div>
									<div class="tableMes2">
										<div style="margin: auto;">
											<span slot="footer" class="dialog-footer" style="display: flex;">
<!--												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="download">{{$t('btn_10')}}</div>-->
											</span>
										</div>
									</div>
								</div>
								<div v-if="quickData=='1'">
									<div class="tableMes2 proSpotMes" style="margin-bottom: 10px;padding: 10px 68px 20px 0;">
										<p style="margin-left: 10px;">{{$t('label_492')}}</p>
										<div style="margin: auto;">
											<!-- <span slot="footer" class="dialog-footer" style="display: flex;">
												<div style="margin-right: 20px;" class="chooseButton sendButton">提交并确认
												</div>
												<div style="margin-right: 20px;" class="chooseButton sendButton">快速处理
												</div>
											</span> -->
											<div class="close" @click="quickData='0'" v-if="quickData=='1'">
												<div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
									<div class="tableMes2">
										<div class="knowledge" style="border: 1px solid black;">
											<div style="width: 100%;" v-for="(item,index) in knowledgeListNew">
												<div class="knowledgeChild">
													<span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}次</span>
													<p style="margin: 10px">
														{{$t('label_393')}}:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}}
													</p>
													<p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
													<p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
												</div>
												<div class="knowledgeChild2">
													<i class="el-icon-remove" style="margin: 20px 0px;color: #ff3300;font-size: 20px" @click="removeKnowledgeListNew(index)"></i>
												</div>
											</div>
										</div>
										<div class="knowledge" style="width: 50px; padding-top: 80px;">
											<div @click="goNew" style="width: 40px; height: 30px;background-color: #43c477;border-radius: 5px; cursor: pointer; margin-left: 5px;">
												<i class="el-icon-d-arrow-left" style="margin: 5px 0 0 9px; font-size: 20px;color: #FFFFFF;"></i>
											</div>
										</div>
										<div class="knowledge">
											<div>
												<div class="tableMes2Box" style="margin: 0px 0px 5px 30px;">
													<p style="margin-top: 5px;margin-right: 20px;">{{$t('label_382')}}</p>
													<div style="width:537px">
														<el-input v-model="knowledgeSelect.faultExplain" @change="selectknowledge"></el-input>
													</div>
												</div>
												<div style="width: 100%;height: 35px; padding-left: 32px;">
													<el-select v-model="knowledgeSelect.faultReasonClassify" :placeholder="$t('input_65')" @change="selectknowledge">
														<el-option :key="$t('label_272')" :label="$t('label_272')" value=""></el-option>
														<el-option v-for="item in cause" :key="item.key" :label="item.val" :value="item.val">
														</el-option>
													</el-select>
													<el-select v-model="knowledgeSelect.faultReason" :placeholder="$t('input_65')" @change="selectknowledge">
														<el-option :key="$t('label_272')" :label="$t('label_272')" value=""></el-option>
														<el-option v-for="item in causeList" :key="item.key" :label="item.val" :value="item.val">
														</el-option>
													</el-select>
												</div>
											</div>
											<div style="height: 155px;overflow-y: auto;">
												<div style="width: 100%;height:100%">
													<el-checkbox-group style="width: 100%;height: auto;" v-model="knowledgeCheckList">
														<el-checkbox :key="index" :label="item" v-for="(item,index) in knowledgeList">
															<div class="knowledgeChild">
																<span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}次{{$t('')}}</span>
																<p style="margin: 10px">
																	{{$t('label_393')}}:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}}
																</p>
																<p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
																<p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
															</div>
														</el-checkbox>
													</el-checkbox-group>
												</div>
											</div>
										</div>
									</div>
									<div class="tableMes2">
										<p style="margin-top: 5px;">{{$t('label_484')}}</p>
										<!-- <div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;">
											<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :file-list="fileList"
											 :http-request="upload2" :show-file-list="false">
												<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
											</el-upload>
										</div> -->
										<!-- 	<div v-for="(item,index) in mainEditList.repairImg" style="width: 50px;height: 50px;margin-left: 30px;position: relative;">
											<img style="width: 50px;height: 50px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item" @click="showImg(item)">
											<i v-if="allList.status=='1'" class="el-icon-close" style="position:absolute;top:0px;right:-20px;color: #000000; cursor:pointer"
											 @click="removeFaultImg2(index)"></i>
										</div> -->
										<div v-for="(item,index) in mainEditList.repairImg" class="photoNewdiv">
											<img v-if="showIcon(item)" class="imgstyle" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
											 @click="previewPdf(item)">
											<img v-if="!showIcon(item)" class="imgstyle" src="../../../static/img/fileText.png" @click="previewPdf(item)">
											<el-tooltip class="item" effect="dark" :content="showName(item)" placement="bottom-start">
												<span class="fileName">{{showName(item)}}</span>
											</el-tooltip>
										</div>
									</div>
									<!-- <div class="tableMes2">
										<div style="margin: auto;">
											<span slot="footer" class="dialog-footer" style="display: flex;">
												<div class="chooseButton sendButton" @click="save(4)">提交</div>
											</span>
										</div>
									</div> -->
								</div>
							</el-tab-pane>
							<el-tab-pane :label="$t('label_415')" name="bei">
								<div v-if="1==1">
									<div class="tableMes2">
										<div class="tableMes2Box" style="width: 700px;">
											<p style="margin-top: 5px;">{{$t('label_514')}}: {{allList.dispatchTime}}</p>
										</div>
										<div class="tableMes2Box" style="margin: 0px 20px 0px 0px;">
											<p style="margin-right: 10px;">{{$t('label_516')}}</p>
											<el-checkbox-group v-model="tableDataEdit.repairMode">
												<el-checkbox v-for="item in malfunctionList" :label="item.val" :key="item.val"></el-checkbox>
											</el-checkbox-group>
											<!-- <el-radio-group v-model="tableDataEdit.repairMode" style="margin-top: 5px;">
												<el-radio v-for="item in malfunctionList" :label="item.val" :key="item.val"></el-radio>
											</el-radio-group> -->
										</div>
									</div>
									<div class="tableMes2">
										<div class="tableMes2Box" style="width: 700px;">
											<p style="margin-top: 5px;margin-right: 10px;width: 80px;word-break:keep-all;width: 180px; ">
												{{$t('label_518')}}</p>
											<el-checkbox-group v-model="tableDataEdit.risk" style="margin-top: 5px;">
												<el-checkbox v-for="item in riskList" :label="item" :key="item"></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="tableMes2Box" style="margin: 0px 20px 0px 0px;">
											<p style="margin-right: 10px;">{{$t('label_521')}}</p>
											<!-- <el-checkbox-group v-model="tableDataEdit.faultLevel">
												<el-checkbox v-for="item in maintainList" :label="item.val" :key="item.val"></el-checkbox>
											</el-checkbox-group> -->
											<el-radio-group v-model="tableDataEdit.faultLevel" style="margin-top: 5px;">
												<el-radio v-for="item in maintainList" :label="item.val" :key="item.val"></el-radio>
											</el-radio-group>
										</div>
									</div>
									<div class="tableMes2">
										<!-- <div class="tableMes2Box">
											<p style="margin-top: 5px;width: 80px;">维修人</p>
											<div style="margin:0px 20px 0px 10px;width:250px">
												<el-autocomplete style="width:100%" v-model="tableDataEdit.repairman" :fetch-suggestions="querySearchAsync"
												 placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect" value-key="fullName" clearable @clear="clearSearch(1)"
												 ref="myAutocomplete"><i slot="suffix" class="el-input__icon el-icon-search"></i></el-autocomplete>
											</div>
										</div> -->
										<div class="tableMes2Box">
											<p style="margin-top: 5px;width: 120px;">{{$t('label_523')}}</p>
											<div style="margin:0px 20px 0px 10px;width:250px">
												<el-select v-model="selectValue" filterable remote reserve-keyword :placeholder="$t('input_66')" :remote-method="remoteMethod"
												 :loading="loading">
													<el-option v-for="item in options" :key="item.id" :label="item.fullName" :value="`${item.id}&@${item.fullName}`">
														<span style="float: left">{{item.fullName}}</span>
														<span style="float: right; color: #8492a6; font-size: 13px">{{item.repairTaskNum}}</span>
													</el-option>
												</el-select>
											</div>
										</div>
										<div class="tableMes2Box">
											<p style="margin-top: 5px;width: 80px;">{{$t('label_527')}}</p>
											<div style="margin:0px 20px 0px 10px;width:250px">
												<el-select v-model="selectValue3" filterable remote reserve-keyword :placeholder="$t('input_66')" :remote-method="remoteMethod3"
												 :loading="loading">
													<el-option v-for="item in options3" :key="item.id" :label="item.fullName" :value="`${item.id}&@${item.fullName}`">
													</el-option>
												</el-select>
											</div>
										</div>
										<!-- <div class="tableMes2Box">
											<p style="margin-top: 5px;">验收人</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-autocomplete style="width:100%" v-model="tableDataEdit.accepter" :fetch-suggestions="querySearchAsync"
												 placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect2" value-key="fullName" clearable
												 @clear="clearSearch(2)" ref="myAutocomplete2"></el-autocomplete>
											</div>
										</div> -->
										<!-- <div class="tableMes2Box">
											<p style="margin-top: 5px;">参与人</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-autocomplete style="width:100%" v-model="tableDataEdit.participants" :fetch-suggestions="querySearchAsync"
												 placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect3" value-key="fullName" clearable
												 @clear="clearSearch(3)" ref="myAutocomplete3"><i slot="suffix" class="el-input__icon el-icon-search"></i></el-autocomplete>
											</div>
										</div> -->
										<div class="tableMes2Box">
											<p style="margin-top: 5px;width: 80px;">{{$t('label_530')}}</p>
											<div style="margin:0px 20px 0px 10px;width:250px">
												<el-select v-model="selectValue2" multiple filterable remote reserve-keyword :placeholder="$t('input_66')"
												 :remote-method="remoteMethod2" :loading="loading">
													<el-option v-for="item in options2" :key="item.id" :label="item.fullName" :value="`${item.id}&@${item.fullName}`">
													</el-option>
												</el-select>
											</div>
										</div>
										<div class="tableMes2Box">
											<p style="margin-top: 5px;width: 130px;">{{$t('label_532')}}</p>
											<div style="margin:5px 20px 0px 10px;width:250px">
												<el-switch v-model="valueOpenClose" active-color="#13ce66" inactive-color="#808080"></el-switch>
											</div>
										</div>
									</div>
									<div class="tableMes2">
										<div class="tableMes2Box" style="width: 100%;">
											<p style="margin-top: 5px; width: 85px;">{{$t('btn_29')}}</p>
											<div style="margin: 0px 0px 0px 5px;width:100%">
												<el-input v-model="tableDataEdit.remarks" type="textarea" :rows="4">
												</el-input>
											</div>
										</div>
									</div>
									<!-- <div class="tableMes2">
										<div style="margin: auto;">
											<span slot="footer" class="dialog-footer" style="display: flex;">
												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="save(1)" v-if="MenuRoleList.indexOf('200')>=0 && lookFlag > 2">派单</div>
												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="save(2)" v-if="lookFlag > 2">接单</div>
											</span>
										</div>
									</div> -->
								</div>
							</el-tab-pane>
							<el-tab-pane :label="$t('label_287')" name="feng" style="height: 100%;">
								<el-tabs tab-position="left" v-model="mainEditSheet" @tab-click="handleClick0" class="fengxianfenxi" style="height: 100%;">
									<!-- <el-tab-pane label="风险分析" name="feng1" style="height: 390px" v-if="receiveList.confirm != '99'">
										<el-checkbox-group v-model="riskConfrimData" style="min-height: 240px;">
											<el-tabs type="border-card" v-model="fengModelHead">
												<template v-for="item in riskConfrimList">
													<el-tab-pane :label="item.head" :name="item.head">
														<div class="riskLiskBox">
															<template v-for="checkItem in item.rkList">
																<div class="ridk">
																	<el-checkbox :label="checkItem.id" border>{{checkItem.content}}</el-checkbox>
																</div>
															</template>
														</div>
													</el-tab-pane>
												</template>
											</el-tabs>
										</el-checkbox-group>
										<div style="margin-left: 280px;border: 1px solid #CCCCCC; width: 900px; height: 100px;margin-top: 30px;display: flex;">
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;" @click="getRiskList2(1)">
													维保人确认</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(1)">
													<span v-if="allList.autograph1 == null||allList.confirm<1">{{'待确认'}}</span>
													<span v-if="allList.autograph1 != null && allList.autograph1.length < 50&&allList.confirm>0">{{allList.autograph1}}</span>
													<img v-if="allList.autograph1 != null && allList.autograph1.length > 50&&allList.confirm>0" :src="allList.autograph1"
													 width="30%" height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;" @click="getRiskList2(2)">
													监护人确认</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(2)">
													<span v-if="allList.autograph2 == null||allList.confirm<2">{{'待确认'}}</span>
													<span v-if="allList.autograph2 != null && allList.autograph2.length < 50&&allList.confirm>1">{{allList.autograph2}}</span>
													<img v-if="allList.autograph2 != null && allList.autograph2.length > 50&&allList.confirm>1" :src="allList.autograph2"
													 width="30%" height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;" @click="getRiskList2(3)">
													操作者确认</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(3)">
													<span v-if="allList.autograph3 == null||allList.confirm<3">{{'待确认'}}</span>
													<span v-if="allList.autograph3 != null && allList.autograph3.length < 50&&allList.confirm>2">{{allList.autograph3}}</span>
													<img v-if="allList.autograph3 != null && allList.autograph3.length > 50&&allList.confirm>2" :src="allList.autograph3"
													 width="30%" height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;" @click="getRiskList2(4)">
													班长确认</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(4)">
													<span v-if="allList.autograph4 == null||allList.confirm<4">{{'待确认'}}</span>
													<span v-if="allList.autograph4 != null && allList.autograph4.length < 50&&allList.confirm>3">{{allList.autograph4}}</span>
													<img v-if="allList.autograph4 != null && allList.autograph4.length > 50&&allList.confirm>3" :src="allList.autograph4"
													 width="30%" height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;" v-if="allList.distinction == '0'">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
													课长确认</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(5)">
													<span v-if="allList.autograph5 == null||allList.confirm<5">{{'待确认'}}</span>
													<span v-if="allList.autograph5 != null && allList.autograph5.length < 50&&allList.confirm>4">{{allList.autograph5}}</span>
													<img v-if="allList.autograph5 != null && allList.autograph5.length > 50&&allList.confirm>4" :src="allList.autograph5"
													 width="30%" height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
										</div>
									</el-tab-pane> -->
									<el-tab-pane :label="$t('label_727')" name="feng2" style="height: 390px">
										<P style="margin-left: 11px;">{{$t('label_560')}}</P>
										<P style="margin-left: 11px;">{{$t('label_564')}}</P>
										<P style="margin-left: 11px;">{{$t('label_568')}}</P>
										<div class="tableMes2 ">
											<div class="tableMes2Box" style="margin-left: 10px;">
												<p style="margin-right: 10px;width: 80px;">{{$t('label_516')}}</p>
												<!-- <el-radio-group v-model="tableDataEdit.repairMode" style="margin-top: 5px;">
													<el-radio v-for="item in malfunctionList" :label="item.val" :key="item.val" disabled></el-radio>
												</el-radio-group> -->
												<el-checkbox-group v-model="tableDataEdit.repairMode">
													<el-checkbox v-for="item in malfunctionList" :label="item.val" :key="item.val"></el-checkbox>
												</el-checkbox-group>
											</div>
										</div>
										<div class="tableMes2">
											<div class="tableMes2Box" style="margin-left: 10px;width: 50%;">
												<p style="margin-right: 10px;width: 80px;word-break:keep-all;width: 180px; ">{{$t('label_518')}}</p>
												<el-checkbox-group v-model="tableDataEdit.risk" style="margin-top: 5px;">
													<el-checkbox v-for="item in riskList" :label="item" :key="item" disabled>
													</el-checkbox>
												</el-checkbox-group>
											</div>
											<div class="tableMes2Box" style="width: 50%;">
												<p style="margin-right: 10px;">{{$t('label_521')}}</p>
												<el-radio-group v-model="tableDataEdit.faultLevel" style="margin-top: 5px;">
													<el-radio v-for="item in maintainList" :label="item.val" :key="item.val" disabled></el-radio>
												</el-radio-group>
											</div>
										</div>
										<div class="tableMes2">
											<div class="tableMes2Box" style="margin-left: 10px;">
												<p style="margin-top: 5px; width: 150px;">{{$t('msg_64')}}</p>
												<div style="margin: 0px 20px 0px 5px;width:215px">
													<el-radio-group v-model="tableDataEdit.needAccepter" size="medium">
														<el-radio-button label="1">{{$t('label_471')}}</el-radio-button>
														<el-radio-button label="0">{{$t('label_474')}}</el-radio-button>
													</el-radio-group>
												</div>
											</div>
											<div class="tableMes2Box" style="margin-left: 10px;">
												<p style="margin-top: 5px; width: 220px;"><span style="color: #ff0000">*</span>{{$t('msg_65')}}</p>
												<div style="margin: 0px 20px 0px 5px;width:215px">
													<el-radio-group v-model="tableDataEdit.needAccuracy" size="medium">
														<el-radio-button label="1">{{$t('label_471')}}</el-radio-button>
														<el-radio-button label="0">{{$t('label_474')}}</el-radio-button>
													</el-radio-group>
												</div>
											</div>
										</div>
										<div class="tableMes2">
											<div class="tableMes2Box" style="margin-left: 10px;overflow:auto;">
												<p style="margin-top: 5px; width: 150px;">{{$t('label_575')}}</p>
												<div style="margin: 10px 20px 0px 0px;width: 600px;">
													<el-checkbox-group v-model="checkList100" @change="setMealSelect1" style="margin-left: 5px;">
														<el-checkbox label="0">{{$t('label_577')}}</el-checkbox>
														<el-checkbox label="1">{{$t('label_579')}}</el-checkbox>
													</el-checkbox-group>
												</div>
												<el-input class="otherInput" v-model="tableDataEdit.delayedDay" :disabled="tableDataEdit.other?false:true"></el-input>
											</div>
										</div>
										<div class="tableMes2">
											<div class="tableMes2Box" style="margin-left: 10px;">
												<p style="margin-right: 10px;width: 80px;">{{$t('label_582')}}</p>
												<div style="margin-top: 5px;">
													<el-checkbox-group v-model="tableDataEdit.reason" :disabled="tableDataEdit.other?false:true">
														<el-checkbox v-for="item in delayedList" :label="item.val" :key="item.val"></el-checkbox>
													</el-checkbox-group>
												</div>
												<el-checkbox :label="$t('label_380')" v-model="tableDataEdit.other1" :disabled="tableDataEdit.other?false:true" style="margin-left: 10px;margin-top: -5px;">{{$t('label_380')}}
													<el-input class="otherInput" v-model="tableDataEdit.otherInput" :disabled="tableDataEdit.other1?false:true"></el-input>
												</el-checkbox>
											</div>
										</div>
										<div class="tableMes2">
											<div style="margin-left: 10px;">
												<p style="margin-right: 10px;width: 100px;">{{$t('label_584')}}</p>
											</div>
										</div>
										<div class="tableMes2">
											<div class="knowledge" style="border: 1px solid black;">
												<div style="width: 99%;height: auto;" v-for="(item,index) in knowledgeListNew">
													<div class="knowledgeChild">
														<span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}{{$t('label_207')}}</span>
														<p style="margin: 10px">
															<!-- 维修时间:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}} -->
															{{$t('label_393')}}: {{item.aveTime}} {{$t('label_395')}}
														</p>
														<p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
														<p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
													</div>
												</div>
											</div>
											<div class="knowledge" style="width: 50px; padding-top: 80px;">
											</div>
											<div class="knowledge">
												<div>
													<div class="tableMes2Box" style="margin: 0px 0px 5px 30px;">
														<p style="margin-top: 5px; width: 80px;">{{$t('label_382')}}</p>
														<div style="width:430px">
															<el-input v-model="knowledgeSelect.faultExplain" @change="selectknowledge"></el-input>
														</div>
														<!-- <div class="buttonBox">
															<div class="chooseButton searchButton" @click="insert">新增</div>
														</div> -->
													</div>
													<div style="width: 100%;height: 35px; padding-left: 32px;">
														<el-select v-model="knowledgeSelect.faultReasonClassify" :placeholder="$t('input_65')" @change="selectknowledge">
															<el-option :key="$t('label_272')" :label="$t('label_272')" value=""></el-option>
															<el-option v-for="item in cause" :key="item.key" :label="item.val" :value="item.val">
															</el-option>
														</el-select>
														<el-select v-model="knowledgeSelect.faultReason" :placeholder="$t('input_65')" @change="selectknowledge">
															<el-option :key="$t('label_272')" :label="$t('label_272')" value=""></el-option>
															<el-option v-for="item in causeList" :key="item.key" :label="item.val" :value="item.val">
															</el-option>
														</el-select>
													</div>
												</div>
												<div style="height: 155px;overflow-y: auto;">
													<div style="width: 100%;height:100%">
														<el-checkbox-group style="width: 100%;height: auto;" v-model="knowledgeCheckList">
															<el-checkbox :key="index" :label="item" v-for="(item,index) in knowledgeList">
																<div class="knowledgeChild">
																	<span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}{{$t('label_207')}}</span>
																	<p style="margin: 10px">
																		{{$t('label_393')}}:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}}
																	</p>
																	<p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
																	<p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
																</div>
															</el-checkbox>
														</el-checkbox-group>
													</div>
												</div>
											</div>
										</div>
										<div class="tableMes2">
											<p style="margin-top: 5px;">{{$t('label_484')}}</p>
											<!-- <div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;">
												<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :file-list="fileList"
												 :http-request="upload2" :show-file-list="false">
													<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
												</el-upload>
											</div> -->
											<!-- <div v-for="(item,index) in mainEditList.repairImg" style="width: 50px;height: 50px;margin-left: 30px;position: relative;">
												<img style="width: 50px;height: 50px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
												 @click="showImg(item)">
												<i v-if="allList.status=='3'||allList.status=='4'" class="el-icon-close" style="position:absolute;top:0px;right:-20px;color: #000000; cursor:pointer"
												 @click="removeFaultImg2(index)"></i>
											</div> -->
											<div v-for="(item,index) in mainEditList.repairImg" class="photoNewdiv">
												<img v-if="showIcon(item)" class="imgstyle" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
												 @click="previewPdf(item)">
												<img v-if="!showIcon(item)" class="imgstyle" src="../../../static/img/fileText.png" @click="previewPdf(item)">
												<el-tooltip class="item" effect="dark" :content="showName(item)" placement="bottom-start">
													<span class="fileName">{{showName(item)}}</span>
												</el-tooltip>
											</div>
										</div>
										<!-- <div class="tableMes2" v-if="receiveList.confirm == '5' || receiveList.confirm == '99'">
											<div style="margin: auto;">
												<span slot="footer" class="dialog-footer" style="display: flex;">
													<div class="chooseButton sendButton" style="margin-right: 20px;" @click="save(5)" v-if="lookFlag > 1">暂存</div>
													<div class="chooseButton sendButton" @click="save(3)" v-if="lookFlag > 1">提交</div>
												</span>
											</div>
										</div> -->
										<div style="margin-left: 280px;border: 1px solid #CCCCCC; width: 900px; height: 100px;display: flex;" v-if="receiveList.distinction == '2'">
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
													{{$t('label_548')}}</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(1)">
													<span v-if="allList.autograph1 == null">{{$t('label_546')}}</span>
													<span v-if="allList.autograph1 != null && allList.autograph1.length < 50">{{allList.autograph1}}</span>
													<img v-if="allList.autograph1 != null && allList.autograph1.length > 50" :src="allList.autograph1" width="30%"
													 height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
													{{$t('操作人确认')}}</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(2)">
													<span v-if="allList.autograph2 == null">{{$t('label_546')}}</span>
													<span v-if="allList.autograph2 != null && allList.autograph2.length < 50">{{allList.autograph2}}</span>
													<img v-if="allList.autograph2 != null && allList.autograph2.length > 50" :src="allList.autograph2" width="30%"
													 height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
													{{$t('生产线确认')}}</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(3)">
													<span v-if="allList.autograph3 == null">{{$t('label_546')}}</span>
													<span v-if="allList.autograph3 != null && allList.autograph3.length < 50">{{allList.autograph3}}</span>
													<img v-if="allList.autograph3 != null && allList.autograph3.length > 50" :src="allList.autograph3" width="30%"
													 height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
													{{$t('生产线班长确认')}}</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(4)">
													<span v-if="allList.autograph4 == null">{{$t('label_546')}}</span>
													<span v-if="allList.autograph4 != null && allList.autograph4.length < 50">{{allList.autograph4}}</span>
													<img v-if="allList.autograph4 != null && allList.autograph4.length > 50" :src="allList.autograph4" width="30%"
													 height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
											<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;" v-if="receiveList.distinction == '2'">
												<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
													{{$t('label_556')}}</div>
												<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(5)">
													<span v-if="allList.autograph5 == null">{{$t('label_546')}}</span>
													<span v-if="allList.autograph5 != null && allList.autograph5.length < 50">{{allList.autograph5}}</span>
													<img v-if="allList.autograph5 != null && allList.autograph5.length > 50" :src="allList.autograph5" width="30%"
													 height="80%" style="transform: rotate(270deg);">
												</div>
											</div>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_597')" name="feng3" style="height: 400px">
										<div class="tabBbox" style="height: 400px">
											<partInfo ref="partInfoDisplay" :show="99"></partInfo>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_600')" name="feng4" style="height: 100%" v-if="receiveList.confirm != '99'">
										<div class="tabBbox" style="height: 100%" v-if="this.allList.appointMeet == 1">
											<div class="buttonBox" style="width: 100%; ">
												<div class="chooseButton searchButton" @click="riskExcel">{{$t('btn_51')}}</div>
												<div class="block" style="margin-left: 20px;">
													<el-date-picker v-model="fengxianlihuiTime1" type="datetime" :placeholder="$t('input_89')" value-format="yyyy-MM-dd HH:mm:ss"
													 format="yyyy-MM-dd HH:mm:ss">
													</el-date-picker>
													-
													<el-date-picker v-model="fengxianlihuiTime2" type="datetime" :placeholder="$t('input_89')" value-format="yyyy-MM-dd HH:mm:ss"
													 format="yyyy-MM-dd HH:mm:ss">
													</el-date-picker>
												</div>
											</div>
											<div style="margin-top: 10px;">
												<span style="font-size: 16px;">1、{{$t('label_605')}}</span>
												<span style="font-size: 12px;font-weight: bold;"></span>
											</div>
											<el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data1" highlight-current-row :span-method="objectSpanMethod1" border
											 style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
												<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex1" width="50">
												</el-table-column>
												<el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
												</el-table-column>
												<el-table-column v-for="(day,index) in feng4Date1" :key="index" :label="getLable1(index)" align="center"
												 :width="150">
													<el-table-column :prop="day" :label="day.substring(8,16).replace(' ',  $t('label_537'))" width="120" align="center">
														<template slot-scope="scope">
															<p v-for="(name,index) in scope.row[day].split(',data:image/')">
																<span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
																<span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
																	 @click="showImg((index==0?'':'data:image/')+name)" />
																</span>
															</p>
														</template>
													</el-table-column>
												</el-table-column>
											</el-table>
											<div style="margin-top: 10px;">
												<span style="font-size: 16px;">2、{{$t('label_683')}}</span>
												<span style="font-size: 12px;font-weight: bold;">{{$t('label_685')}}</span>
											</div>
											<el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data2" highlight-current-row :span-method="objectSpanMethod2" border
											 style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
												<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex2" width="50">
												</el-table-column>
												<el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
												</el-table-column>
												<el-table-column v-for="(day,index) in feng4Date2" :key="index" :label="getLable1(index)" align="center"
												 :width="150">
													<el-table-column :prop="day" :label="day.substring(8,16).replace(' ',  $t('label_537'))" width="120" align="center">
														<template slot-scope="scope">
															<p v-for="(name,index) in scope.row[day].split(',data:image/')">
																<span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
																<span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
																	 @click="showImg((index==0?'':'data:image/')+name)" />
																</span>
															</p>
														</template>
													</el-table-column>
												</el-table-column>
											</el-table>
											<div style="margin-top: 10px;">
												<span style="font-size: 16px;">3、{{$t('label_688')}}</span>
												<span style="font-size: 12px;font-weight: bold;">{{$t('msg_69')}}</span>
											</div>
											<el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data3" highlight-current-row :span-method="objectSpanMethod3" border
											 style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
												<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex3" width="50">
												</el-table-column>
												<el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
												</el-table-column>
												<el-table-column v-for="(day,index) in feng4Date3" :key="index" :label="getLable1(index)" align="center"
												 :width="150">
													<el-table-column :prop="day" :label="day.substring(8,16).replace(' ', $t('label_537'))" width="120" align="center">
														<template slot-scope="scope">
															<p v-for="(name,index) in scope.row[day].split(',data:image/')">
																<span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
																<span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
																	 @click="showImg((index==0?'':'data:image/')+name)" />
																</span>
															</p>
														</template>
													</el-table-column>
												</el-table-column>
											</el-table>
											<div style="margin-top: 10px;">
												<span style="font-size: 16px;">4、{{$t('label_693')}}</span>
												<span style="font-size: 12px;font-weight: bold;"></span>
											</div>
											<el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data4" highlight-current-row :span-method="objectSpanMethod4" border
											 style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
												<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex4" width="50">
												</el-table-column>
												<el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
												</el-table-column>
												<el-table-column v-for="(day,index) in feng4Date4" :key="index" :label="getLable1(index)" align="center"
												 :width="150">
													<el-table-column :prop="day" :label="day.substring(8,16).replace(' ', $t('label_537'))" width="120" align="center">
														<template slot-scope="scope">
															<p v-for="(name,index) in scope.row[day].split(',data:image/')">
																<span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
																<span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
																	 @click="showImg((index==0?'':'data:image/')+name)" />
																</span>
															</p>
														</template>
													</el-table-column>
												</el-table-column>
											</el-table>
										</div>
										<div class="tabBbox" style="height: 100%" v-else>
											<div class="buttonBox" style="width: 100%; ">
												<div class="chooseButton searchButton" @click="riskExcel">{{$t('btn_51')}}</div>
											</div>
											<el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data" highlight-current-row :span-method="objectSpanMethod" border
											 style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
												<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex0" width="50">
												</el-table-column>
												<el-table-column prop="item" :label="$t('label_695')" header-align="center" align="left" width="400">
												</el-table-column>
												<el-table-column v-for="(day,index) in feng4Date" :key="index" :label="getLable(index)" align="center"
												 :width="150">
													<!-- <el-table-column :prop="day" :label="day.substring(0,16)" width="120" align="center" :width="150">
														<template slot-scope="scope">
															<p v-for="name in scope.row[day].split(',')">{{name=='1'?'✔':name=='0'?'✖':name}}</p>
														</template>
												    </el-table-column> -->
													<el-table-column :prop="day" :label="day.substring(0,16)" width="120" align="center">
														<template slot-scope="scope">
															<p v-for="(name,index) in scope.row[day].split(',data:image/')">
																<span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
																<span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
																	 @click="showImg((index==0?'':'data:image/')+name)" />
																</span>
															</p>
														</template>
													</el-table-column>
												</el-table-column>
											</el-table>
										</div>

									</el-tab-pane>
								</el-tabs>
							</el-tab-pane>
							<el-tab-pane :label="$t('label_608')" name="receive">
								<div>
									<div class="tableMes2">
										<div class="tableMes2Box abc" style="width: 100%;">
											<p style="margin-left: 10px; width: 170px;">{{$t('label_612')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:100%;height: 110px;border: 1px solid black;overflow:auto;">
												<div style="margin-left: 10px;">
													<p style="display: inline-block;">{{$t('label_616')}}: </p>
													<el-checkbox-group v-model="tableDataEdit.productTrackList" style="display: inline-block;">
														<el-checkbox v-for="item in productTrackList" :label="item.val" :key="item.val" :disabled="lookFlag==99">
														</el-checkbox>
													</el-checkbox-group>
													<el-checkbox :label="$t('label_380')" v-model="tableDataEdit.other2" style="margin-left: 10px;" :disabled="lookFlag==99">{{$t('label_380')}}
														<el-input class="otherInput" v-model="tableDataEdit.otherInput2" :disabled="tableDataEdit.other2?false:true"></el-input>
													</el-checkbox>
												</div>
												<div style="margin-left: 10px;">
													<p style="display: inline-block;">{{$t('label_620')}}: </p>
													<el-checkbox-group v-model="tableDataEdit.bulkTrackList" style="display: inline-block;">
														<el-checkbox v-for="item in bulkTrackList" :label="item.val" :key="item.val" :disabled="lookFlag==99"></el-checkbox>
													</el-checkbox-group>
												</div>
												<p style="margin-left: 10px;">{{$t('label_624')}}: <el-input class="otherInput" v-model="tableDataEdit.importants" style="width: 100px;"></el-input>
												</p>
											</div>
										</div>
									</div>
									<div class="tableMes2" v-if="this.allList.needAccepter == '1'">
										<div class="tableMes2Box" style="width: 100%;">
											<p style="margin-top: 5px; width: 120px;margin-left: 10px;">{{$t('label_628')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:100%;">
												<el-input v-model="receiveList.idea" type="textarea" :rows="2">
												</el-input>
											</div>
										</div>
									</div>
									<div class="tableMes2" v-if="this.allList.needAccepter == '1'">
										<div class="tableMes2Box" style="width: 100%;">
											<p style="margin-top: 5px; width: 120px;margin-left: 10px;">{{$t('label_632')}}</p>
											<div style="margin: 0px 20px 0px 5px;width:100%;">
												<el-input v-model="receiveList.accord" type="textarea" :rows="2">
												</el-input>
											</div>
										</div>
									</div>
									<div style="margin-left: 450px; width: 650px; height: 100px;margin-top: 10px;display: flex;">
										<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;" v-if="this.allList.needAccepter == '1'">
											<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
												{{$t('label_636')}}</div>
											<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive1(6)">
												<span v-if="allList.autograph6 == null">{{'待验收'}}{{$t('')}}</span>
												<span v-if="allList.autograph6 != null && allList.autograph6.length < 50">{{allList.autograph6}}</span>
												<img v-if="allList.autograph6 != null && allList.autograph6.length > 50" :src="allList.autograph6" width="30%"
												 height="80%" style="transform: rotate(270deg);">
											</div>
										</div>
										<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
											<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
												{{$t('label_640')}}</div>
											<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive1(7)">
												<span v-if="allList.autograph7 == null">{{$t('label_314')}}</span>
												<span v-if="allList.autograph7 != null && allList.autograph7.length < 50">{{allList.autograph7}}</span>
												<img v-if="allList.autograph7 != null && allList.autograph7.length > 50" :src="allList.autograph7" width="30%"
												 height="80%" style="transform: rotate(270deg);">
											</div>
										</div>
										<!-- <div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
											<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
												报修人</div>
											<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive(8)">
												{{allList.autograph7 != null ? allList.autograph7 : '待验收'}}
											</div>
										</div> -->
										<div style="border: 1px solid #CCCCCC; width: 225px; height: 100px;">
											<div style="border-bottom: 1px solid #CCCCCC;width: 100%; height: 20px;text-align: center;">
												{{$t('label_644')}}</div>
											<div style="width: 100%; height: 100%;text-align: center;line-height: 80px;" @click="receive1(8)">
												<span v-if="allList.autograph8 == null">{{$t('label_314')}}</span>
												<span v-if="allList.autograph8 != null && allList.autograph8.length < 50">{{allList.autograph8}}</span>
												<img v-if="allList.autograph8 != null && allList.autograph8.length > 50" :src="allList.autograph8" width="30%"
												 height="80%" style="transform: rotate(270deg);">
											</div>
										</div>
									</div>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="$t('label_696')" :visible.sync="dialogImg" append-to-body :close-on-click-modal='false' width="800px"
		 :before-close="handleCloseImg" custom-class="dialogBox">
			<img :src="imgUrl" style="transform: rotate(270deg); width: 380px;height:600px; margin-left: 200px;" />
		</el-dialog>
		<!-- <el-dialog title="图片" :visible.sync="dialogImg" append-to-body :close-on-click-modal='false' width="800px" id="dialogImg"
		 top="10%" :before-close="closeImg" custom-class="dialogBox" >
			<div class="dialogBoxMes" style="padding:0 20px;">
				<img style="width: 100%;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+img" >
			</div>
		</el-dialog> -->
		<!-- <el-dialog title="视频" :visible.sync="dialogVideo" append-to-body :close-on-click-modal='false' width="800px" id="dialogImg"
		 top="10%" :before-close="closeImg" custom-class="dialogBox" >
			<div class="dialogBoxMes" style="padding:20px 20px;">
				<video width="100%" height="500" controls autoplay="autoplay">
					<source :src="$store.getters.getPostUrl+'mes/sysFile/download/'+img" >
				</video>
			</div>
		</el-dialog> -->
		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" ref="exportBox"></exportMes>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/maintainTree";
	import maintenance from "@/assets/js/maintenance/maintenance.js";
	import malfunction from "@/assets/js/malfunction/malfunction.js";
	import exportMes from "@/components/list/export/export";
	import file from "@/assets/js/file/file.js";
	import partInfo from "@/components/list/repair/partInfo";
	export default {
		name: 'spotResumePage',
		components: {
			Page,
			tree,
			exportMes,
			partInfo
		},
		data() {
			return {
				valueOpenClose: false,
				timers:null,
				knowledgeListInsert: {
					id: '',
					faultPhenomenon: '',
					faultExplain: '',
					faultReason: '',
					solution: '',
					precaution: '',
					frequency: '',
					equipmentTypeId: '',
					faultReasonClassify: '',
					checkList1: [],
					checkList2: [],
					checkList3: [],
					other: '',
					otherInput: '',
					other1: '',
					otherInput1: '',
					impact: '',
					impactKey: '',
					impactVal: '',
					precautionKey: '',
					precautionVal: '',
					fault: '',
					typeName: ''
				},
				deviceList: [],
				feng4Data: [],
				feng4Date: [],
				feng4Date1: [],
				feng4Data1: [],
				feng4Date2: [],
				feng4Data2: [],
				feng4Date3: [],
				feng4Data3: [],
				feng4Date4: [],
				feng4Data4: [],
				fengxianlihuiTime1: '',
				fengxianlihuiTime2: '',
				switched: true,
				faultLevel2: [{
					value: '',
					label: this.$t('label_272')
				}, {
					value: this.$t('label_58'),
					label: this.$t('label_58')
				}, {
					value: this.$t('label_63'),
					label: this.$t('label_63')
				}, {
					value: this.$t('label_67'),
					label: this.$t('label_67')
				}, {
					value: this.$t('label_837'),
					label: this.$t('label_837')
				}],
				pageNum: 1,
				select: 0,
				pageSize: 10,
				pageCount: 0,
				height: 500,
				Readytime: '',
				getTreeMes: '1',
				checkComfrim: [this.$t('label_709'), this.$t('label_712'), this.$t('label_714')],
				checked: false,
				dialogSpotResult: false,
				dialogSpotTimeEdit: false,
				dialogSpotBatchTimeEdit: false,
				dialogImg: false,
				dialogVideo: false,
				fengXianConfrim: [],
				info: {},
				faultList: [],
				guzhangList: [],
				tableDataBeijian: [{
					name: this.$t('齿轮箱油'),
					type: 'ArNo 6120-10',
					num: '2.8',
					unit: 'L',
					produce: this.$t('大连久鹏')
				}, {
					name: this.$t('齿轮箱油'),
					type: 'ArNo 6120-10',
					num: '2.8',
					unit: 'L',
					produce: this.$t('大连久鹏')
				}, {
					name: this.$t('齿轮箱油'),
					type: 'ArNo 6120-10',
					num: '2.8',
					unit: 'L',
					produce: this.$t('大连久鹏')
				}, ],
				tableDataTree: [],
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableDataTreeTime: [],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				mainEditTree: 'project',
				deviceDetailMes: {},
				tableDataTreeInfo: [],
				typeName: '',
				deptName: '',
				status: '',
				faultLevel: '',
				styleObject1: {
					width: '0%'
				},
				styleObject2: {
					width: '100%',
					background: '#3fb393'
				},
				styleObject3: {
					width: '0%'
				},
				styleObject4: {
					'padding-left': '0%'
				},
				styleObject5: {
					'padding-right': '0%'
				},
				styleObject6: {
					'padding-right': '0%'
				},
				styleObject7: {
					'padding-right': '0%'
				},
				spotStatusNumList: [{
					text: this.$t('label_272'),
					type: '0',
					check: false,
					num: '4',
					color: '#000000'
				}, {
					text: this.$t('label_299'),
					type: '1',
					check: true,
					num: '0',
					color: '#e60000'
				}, {
					text: this.$t('label_303'),
					type: '2',
					check: true,
					num: '0',
					color: '#e60000'
				}, {
					text: this.$t('label_307'),
					type: '3',
					check: true,
					num: '0',
					color: '#e60000'
				}, {
					text: this.$t('label_311'),
					type: '4',
					check: true,
					num: '1',
					color: '#ffb400'
				}, {
					text: this.$t('label_314'),
					type: '5',
					check: true,
					num: '1',
					color: '#e60000'
				}, {
					text: this.$t('label_318'),
					type: '6',
					check: true,
					num: '1',
					color: '#ffb400'
				}, {
					text: this.$t('label_829'),
					type: '7',
					check: true,
					num: '1',
					color: '#3fb393'
				}, {
					text: this.$t('label_326'),
					type: '8',
					check: true,
					num: '0',
					color: '#aeaeae'
				}],
				img: '',
				orderNo: '',
				tableDataTreeTimeExport: [],
				exportTitle: this.$t('label_697'),
				exportList: [{
						column: 'orderNo',
						title: this.$t('label_41'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'status',
						title: this.$t('label_412'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'superior',
						title: this.$t('label_593'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'faultPhenomenon',
						title: this.$t('label_348'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'reportPerson',
						title: this.$t('label_50'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'repairman',
						title: this.$t('label_54'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
				],
				mainEditList: {
					equipmentId: '',
					faultPhenomenon: '',
					devicName: '',
					reportPerson: '',
					mobile: '',
					urgentLevel: '',
					faultSource: '',
					stop: '1',
					expectTime: '',
					reportTime: '',
					stopTime: '',
					faultExplain: '',
					faultImg: '',
					status: '1',
					superior: '',
					repairImg: [],
					deptId: '',
					distinction: '0',
					fault: '',
				},
				faultPhenomenonList: [],
				allList: [],
				stepsSimple: false,
				quickData: '0',
				urgentList: [],
				fileList: [],
				lookFlag: 4,
				tableDataEdit: {
					id: '',
					risk: [],
					repairMode: [],
					faultLevel: '',
					remarks: '',
					repairman: [],
					repairmanId: '',
					accepter: '',
					accepterId: '',
					participants: '',
					participantsId: '',
					needAccepter: 1,
					importants: '',
					delayedDay: '',
					other: '',
					other1: '',
					otherInput: '',
					other2: '',
					otherInput2: '',
					delayedReason: '',
					reason: [],
					productTrackList: [],
					bulkTrackList: []
				},
				malfunctionList: [],
				riskList: [],
				maintainList: [],
				loading: false,
				selectValue: '',
				options: [],
				selectValue3: '',
				options3: [],
				selectValue2: [],
				options2: [],
				mainEditSheet: 'feng2',
				receiveList: {
					idea: '',
					accord: '',
					userName: '',
					passWord: '',
					autograph: '',
					confirm: '',
					taskId: '',
					riskIdList: [],
					id: '',
					flag: "0",
					distinction: ''
				},
				riskConfrimData: [],
				riskConfrimList: [],
				checkList100: [],
				delayedList: [],
				knowledgeListNew: [],
				knowledgeSelect: {
					faultReasonClassify: '',
					faultReason: '',
					faultExplain: '',
				},
				cause: [],
				causeList: [],
				knowledgeCheckList: [],
				knowledgeList: [],
				productTrackList: [],
				bulkTrackList: [],
				id: '',
				fengModelHead: '',
				imgUrl: '',
				showIconList: {},
				showNameList: [],
				timer: null,
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			showName(row) {
				file.selectFileName(row).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.showNameList[row] = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				return this.showNameList[row]
			},
			handleCloseImg() {
				this.dialogImg = false;
			},
			riskExcel() {
				if (this.allList.appointMeet == 1) {
					window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentRepairRecord/excel1/' + this.id;
				} else {
					window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentRepairRecord/excel/' + this.id;
				}
			},
			getRiskList2(status) {
				if (this.allList.appointMeet == 1) {
					this.saveStatus = status
					this.riskConfrimData = [];
					this.riskConfrimList = [];
					let param = {
						taskId: this.receiveList.taskId,
						status: status
					}
					malfunction.riskDetailListAll(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.riskConfrimList = data.data;
							this.fengModelHead = this.riskConfrimList[0].head;
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					this.getRiskList()
				}
			},
			receive(param) {
				if (param == '1') {
					if (this.allList.autograph1 != null && this.allList.autograph1.length > 50) {
						this.imgUrl = this.allList.autograph1;
						this.dialogImg = true;
					}
				} else if (param == '2') {
					if (this.allList.autograph2 != null && this.allList.autograph2.length > 50) {
						this.imgUrl = this.allList.autograph2;
						this.dialogImg = true;
					}
				} else if (param == '3') {
					if (this.allList.autograph3 != null && this.allList.autograph3.length > 50) {
						this.imgUrl = this.allList.autograph3;
						this.dialogImg = true;
					}
				} else if (param == '4') {
					if (this.allList.autograph4 != null && this.allList.autograph4.length > 50) {
						this.imgUrl = this.allList.autograph4;
						this.dialogImg = true;
					}
				} else if (param == '5') {
					if (this.allList.autograph5 != null && this.allList.autograph5.length > 50) {
						this.imgUrl = this.allList.autograph5;
						this.dialogImg = true;
					}
				}
			},
			selectRisk(id) {
				let param = {
					id: id,
					type: 1
				};
				file.selectRisk(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.riskList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			export (param) {
				malfunction.exportList(param, this.switched).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTimeExport = data.data;
						for (var i = 0; i < this.tableDataTreeTimeExport.length; i++) {
							this.tableDataTreeTimeExport[i].status = this.spotStatusNumList[this.tableDataTreeTimeExport[i]
								.status].text
              let element = this.tableDataTreeTimeExport[i];
              this.tableDataTreeTimeExport[i].superior = element.superior + ' ' + element.tname + ' ' + element.ename + ' ' + element.code
              this.tableDataTreeTimeExport[i].faultPhenomenon = element.faultPhenomenon + ' ' + element.faultExplain
              this.tableDataTreeTimeExport[i].reportPerson = element.reportPerson + ' ' + element.reportTime
              this.tableDataTreeTimeExport[i].repairman = element.repairman + ' ' + element.repairBeginTime
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndex0(index) {
				if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data.length) {
					return this.$t('label_40')
				}
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndex1(index) {
				if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data1.length) {
					return this.$t('label_44')
				}
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndex2(index) {
				if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data2.length) {
					return $t('label_49')
				}
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndex3(index) {
				if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data3.length) {
					return this.$t('label_53')
				}
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndex4(index) {
				if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data4.length) {
					return this.$t('label_57')
				}
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			selectProp: function(index) {
				// console.log(index)
				this.select = index
			},
			closeImg() {
				this.dialogImg = false;
				this.dialogVideo = false;
			},
			show(id, type) {
				this.img = id;
				if (type == "video") {
					this.dialogVideo = true;
				} else if (type == "photo") {
					this.dialogImg = true;
				}

			},
			handler(row) {
				this.status = row.status;
				this.typeName = '';
				this.deptName = '',
					this.id = row.id,
					maintenance.selectByIdPart({
						id: row.id
					}).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.tableDataBeijian = data.data
						}
					}).catch((response) => {
						console.log(response)
					})
				maintenance.selectByIdRisk({
					id: row.id
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						for (var i = 0; i < this.fengXianConfrim.length; i++) {
							if (data.data[this.fengXianConfrim[i].key] != null && data.data[this.fengXianConfrim[i].key] != '') {
								var check = [];
								for (var key in data.data[this.fengXianConfrim[i].key]) {
									check.push({
										mes: key
									})
									if (data.data[this.fengXianConfrim[i].key][key][data.data[this.fengXianConfrim[i].key][key]
											.length - 1
										].abnormalFlag ==
										1) {
										this.checkComfrim.push(key)
									}
								}
								this.fengXianConfrim[i].check = check;
							}
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleClose() {
				this.dialogSpotResult = false;
			},
			showIcon(row) {
				file.selectFileType(row).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						let type = data.data;
						if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1 || type.indexOf(
								".gif") != -1) {
							this.showIconList[row] = true;
						} else {
							this.showIconList[row] = false;
						}
					}
				}).catch((response) => {
					console.log(response)
				})
				return this.showIconList[row]
			},
			results() {
				if (Object.keys(this.info).length > 0) {
					this.dialogSpotResult = true
					this.mainEditTree = 'project';
					// this.allList.dispatchTime = this.getNow();
					this.mainEditList.devicName = this.info.ename;
					this.mainEditList.reportPerson = this.allList.reportPerson;
					this.mainEditList.deptId = this.allList.deptId;
					this.mainEditList.superior = this.allList.superior;
					this.mainEditList.mobile = this.allList.mobile;
					this.mainEditList.typeName = this.allList.typeName1;
					for (var key in this.urgentList) {
						if (this.urgentList[key].key == this.allList.urgentLevel) {
							this.mainEditList.urgentLevel = this.urgentList[key].val;
						}
					}
					this.mainEditList.faultSource = this.allList.faultSource;
					this.mainEditList.stop = this.allList.stop;
					this.mainEditList.expectTime = this.allList.expectTime;
					this.mainEditList.reportTime = this.allList.reportTime;
					this.mainEditList.stopTime = this.allList.stopTime;
					this.mainEditList.faultExplain = this.allList.faultExplain;
					this.fengxianlihuiTime1 = this.allList.repairPlanBeginTime
					this.fengxianlihuiTime2 = this.allList.repairPlanEndTime
					// this.mainEditList.faultImg = this.allList.faultImg;
					// this.mainEditList.repairImg = this.allList.repairImg;
					if (this.allList.faultImg != null && this.allList.faultImg != '') {
						this.mainEditList.faultImg = this.allList.faultImg.split(',')
					} else {
						this.mainEditList.faultImg = []
					}
					if (this.allList.repairImg != null && this.allList.repairImg != '') {
						this.mainEditList.repairImg = this.allList.repairImg.split(',')
					} else {
						this.mainEditList.repairImg = []
					}
					console.log(6678);
					console.log(this.allList);
					this.receiveList.idea = this.allList.idea;
					this.receiveList.accord = this.allList.accord;
					this.receiveList.confirm = this.allList.confirm.toString();
					this.receiveList.distinction = this.allList.distinction.toString();
					if (this.allList.delayed != null && this.allList.delayed.toString() == "1") {
						this.checkList100.push(this.allList.delayed.toString());
						this.tableDataEdit.other = true;
						this.tableDataEdit.delayedDay = this.allList.delayedDay;
					} else {
						if (this.allList.delayed != null) {
							this.checkList100.push(this.allList.delayed.toString());
						}
						this.tableDataEdit.other = false;
						this.tableDataEdit.delayedDay = "";
						this.tableDataEdit.otherInput = "";
					}
					let reason = [];
					if (this.allList.delayedReason != null && this.allList.delayedReason != "") {
						reason = this.allList.delayedReason.split(',');
					}
					let delayed = [];
					for (var key in this.delayedList) {
						delayed.push(this.delayedList[key].val);
					}
					let aabb = this.getDifferentData(reason, delayed);
					this.tableDataEdit.other1 = false;
					if (this.delayedList.length > 0 && reason.length > 0 && reason[0] != '') {
						// this.tableDataEdit.other1 = true;
						// this.tableDataEdit.otherInput = aabb[0];
						for (var i = 0; i < reason.length; i++) {
							var num = 0;
							for (var j = 0; j < this.delayedList.length; j++) {
								if (reason[i] == this.delayedList[j].val) {
									num++;
								}
							}
							if (num == 0) {
								this.tableDataEdit.other1 = true;
								this.tableDataEdit.otherInput = reason[i];
								reason.splice(i, 1);
								break;
							}
						}
					}
					this.tableDataEdit.reason = reason;
					let productTrackVal = [];
					let bulkTrackVal = [];
					let productTrackKey = [];
					let bulkTrackKey = [];
					if (this.allList.productTrackVal != null) {
						productTrackVal = this.allList.productTrackVal.split(',');
					}
					if (this.allList.productTrackKey != null) {
						productTrackKey = this.allList.productTrackKey.split(',');
					}
					if (this.allList.bulkTrackVal != null) {
						bulkTrackVal = this.allList.bulkTrackVal.split(',');
					}
					if (this.allList.bulkTrackKey != null) {
						bulkTrackKey = this.allList.bulkTrackKey.split(',');
					}
					this.tableDataEdit.productTrackList = productTrackVal;
					this.tableDataEdit.bulkTrackList = bulkTrackVal;
					for (var key in productTrackKey) {
						if (productTrackKey[key] == '0') {
							this.tableDataEdit.other2 = true;
							this.tableDataEdit.otherInput2 = productTrackVal[productTrackVal.length - 1];
						}
					}
					// this.tableDataEdit.id = this.info.id;
					// this.receiveList.id = this.info.id;
					// this.commitList.id = this.info.id;
					this.receiveList.taskId = this.info.id;
					this.$nextTick(() => {
						this.$refs.partInfoDisplay.selectDataList(this.info.id);
					})
					if (this.allList.risk != null && this.allList.risk != '') {
						this.tableDataEdit.risk = JSON.parse(this.allList.risk)
					} else {
						this.tableDataEdit.risk = [];
					}
					if (this.allList.repairMode != null && this.allList.repairMode != '') {
						this.tableDataEdit.repairMode = JSON.parse(this.allList.repairMode)
					} else {
						this.tableDataEdit.repairMode = [];
					}
					// this.tableDataEdit.repairMode = this.allList.repairMode;
					this.tableDataEdit.faultLevel = this.allList.faultLevel;
					if (this.allList.needAccepter == null) {
						this.tableDataEdit.needAccepter = 1
					} else {
						this.tableDataEdit.needAccepter = this.allList.needAccepter;
					}
					if (this.allList.needAccuracy == null) {
						this.tableDataEdit.needAccuracy = 0;
					} else {
						this.tableDataEdit.needAccuracy = this.allList.needAccuracy;

					}
					this.tableDataEdit.importants = this.allList.importants;
					this.knowledgeListNew = this.allList.list;
					this.tableDataEdit.remarks = this.allList.remarks;
					if (this.allList.repairman != null) {
						this.options = [{
							id: this.allList.repairmanId,
							fullName: this.allList.repairman
						}];
						this.selectValue = this.allList.repairmanId + "&@" + this.allList.repairman;
					} else {
						this.options = [];
						this.selectValue = '';
					}
					if (this.allList.accepter != null) {
						this.options3 = [{
							id: this.allList.accepterId,
							fullName: this.allList.accepter
						}];
						this.selectValue3 = this.allList.accepterId + "&@" + this.allList.accepter;
					} else {
						this.options3 = [];
						this.selectValue3 = '';
					}
					if (this.allList.participants != "" && this.allList.participants != null && this.allList.participantsId !=
						null) {
						let participantsIdArr = this.allList.participantsId.split(",");
						let participantsArr = this.allList.participants.split(",");
						let selectValue2 = [];
						let options2 = [];
						for (let i = 0; i < participantsArr.length; i++) {
							selectValue2.push(participantsIdArr[i] + "&@" + participantsArr[i]);
							options2.push({
								id: participantsIdArr[i],
								fullName: participantsArr[i]
							})
						}
						this.options2 = options2;
						this.selectValue2 = selectValue2;
					} else {
						this.options2 = [];
						this.selectValue2 = [];
					}
					this.mainEditList.faultPhenomenon = this.allList.faultPhenomenon.split(",");
					this.mainEditList.fault = '';
					this.knowledgeListInsert.fault = '';
					var num = '';
					var ketI = 0;
					for (var key in this.mainEditList.faultPhenomenon) {
						var n = 0;
						for (var i in this.faultPhenomenonList) {
							if (this.mainEditList.faultPhenomenon[key] == this.faultPhenomenonList[i].val) {
								n++;
							}
						}
						if (n == 0) {
							ketI = key;
							num = 1;
						}
					}
					if (num != '') {
						this.mainEditList.fault = this.mainEditList.faultPhenomenon[ketI];
						this.mainEditList.faultPhenomenon[ketI] = this.$t('label_380');
					}
					this.knowledgeListInsert.faultPhenomenon = this.mainEditList.faultPhenomenon[0];
					if (this.knowledgeListInsert.faultPhenomenon == this.$t('label_380')) {
						this.knowledgeListInsert.fault = this.mainEditList.fault;
					}
					// this.tableDataEdit.accepter = this.allList.accepter;
					// this.tableDataEdit.accepterId = this.allList.accepterId;
					this.selectknowledge();
					this.getRiskList2(1);
					this.dialogSpotResult = true;
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
				// if (this.status == 2 || this.status == 4) {
				// 	if (this.tableDataTree == null || this.tableDataTree == '') {
				// 		return;
				// 	}
				// 	this.dialogSpotResult = true
				// } else {
				// 	utils.messageAlert("请选择保养状态是正常保养或逾期保养的数据", this.$t('label_358'), this.$t('label_100'));
				// }
			},
			handleCurrentChangeAll(info) {},
			handleCurrentChangeDevice(info) {},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			handleCurrentChangeTreeTime(info) {
				this.info = info;
				this.id = info.id;
				this.selectRisk(info.equipmentId);
				this.selectAll();
			},
			handleNodeClickDevice(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '1';
				} else {
					this.getTreeMes = '1';
				}
			},
			handleNodeClickArea(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '1';
				} else {
					this.getTreeMes = '1';
				}
			},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				// this.search({
				// 	pageNum: 1,
				// 	pageSize: this.pageSize,
				// });
			},
			handleClickSpot(tab, event) {
				// console.log(tab, event);
			},
			handleClickDevice(tab, event) {
				// console.log(tab, event);
			},
			search(param) {
				this.tableDataTreeTime = [];
				this.info = {};
				let status = [];
				for (var i = 0; i < this.spotStatusNumList.length; i++) {
					if (this.spotStatusNumList[i].check == true) {
						status.push(i)
					}
				}
				var dataParam = {
					beginTime: this.Readytime[0] + " 00:00:00",
					endTime: this.Readytime[1] + " 23:59:59",
					faultLevel: this.faultLevel,
					status: status,
					orderNo: this.orderNo,
					type: this.deviceDetailMes.type,
					id: this.deviceDetailMes.id,
				}
				// var dataParam = {
				// 	beginTime: this.Readytime[0],
				// 	endTime: this.Readytime[1],
				// 	code: this.code,
				// 	status: status,
				// 	type: this.deviceDetailMes.type,
				// 	id: this.deviceDetailMes.id,
				// }
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.searchPage(newParam);
				this.searchStauts(newParam);
				this.export(dataParam);
			},
			searchPage(param) {
				malfunction.getPage(param, this.switched).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchStauts(param) {
				malfunction.getRecordStatus(param, this.switched).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.spotStatusNumList[0].num = data.data.num0
						this.spotStatusNumList[1].num = data.data.num1
						this.spotStatusNumList[2].num = data.data.num2
						this.spotStatusNumList[3].num = data.data.num3
						this.spotStatusNumList[4].num = data.data.num4
						this.spotStatusNumList[5].num = data.data.num5
						this.spotStatusNumList[6].num = data.data.num6
						this.spotStatusNumList[7].num = data.data.num7
						this.spotStatusNumList[8].num = data.data.num8
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {};
					this.exportTitle = this.$t('label_697') + utils.getDayFormatDateWithoutSeperator() + this.$t('label_272');
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else {
					this.deviceDetailMes = data;
          this.exportTitle = this.$t('label_697') + utils.getDayFormatDateWithoutSeperator() + this.deviceDetailMes.name;
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				}
			},
			getRiskList1() {
        file.getByDictIdALL({dictId: 7, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.fengXianConfrim = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getRiskList().then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.fengXianConfrim = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			// riskExcel() {
			// 	window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel3?time=' + this
			// 		.Readytime[0]
			// 		.substring(0, 7) + "&id=" + this.id;
			// },
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getBeforeTime() {
				var time = (new Date).getTime() - 24 * 60 * 60 * 1000;
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getThreeDaysAgo() {
				let myDate = new Date();
				let lw = new Date(myDate - 1000 * 60 * 60 * 24 * 30); //最后一个数字30可改，30天的意思
				let lastY = lw.getFullYear();
				let lastM = lw.getMonth() + 1;
				let lastD = lw.getDate();
				let startData =
					lastY +
					"-" +
					(lastM < 10 ? "0" + lastM : lastM) +
					"-" +
					(lastD < 10 ? "0" + lastD : lastD); //三十天之前日期
				return startData;
			},
			querySearchAsync1(queryString, cb) {
				file.selectByName(this.mainEditList.devicName).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleSelect4(item) {
				this.mainEditList.devicName = item.name;
				this.mainEditList.equipmentId = item.id;
				this.mainEditList.superior = item.superior;
				this.mainEditList.deptId = item.deptId;
			},
			stopChange(val) {
				if (val == 0) {
					this.mainEditList.stopTime = "";
				}
			},
			upload(file1) {
				if (this.mainEditList.faultImg.length == 5) {
					utils.messageAlert(this.$t('msg_72'), this.$t('label_358'), this.$t('label_100'));
					return;
				}
				var formData = new FormData();
				formData.append('file', file1.file);
				formData.append('organizationId', this.mainEditList.deptId);
				file.upload(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.mainEditList.faultImg.push(data.data)
						// this.tableDataEdit.fileId = data.data
						this.$message({
							message: this.$t('msg_15'),
							type: 'success'
						});
						this.chooseFile = true;
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			upload2(file1) {
				if (this.mainEditList.repairImg.length == 5) {
					utils.messageAlert(this.$t('msg_72'), this.$t('label_358'), this.$t('label_100'));
					return;
				}
				var formData = new FormData();
				formData.append('file', file1.file);
				formData.append('organizationId', this.mainEditList.deptId);
				file.upload(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.mainEditList.repairImg.push(data.data)
						// this.tableDataEdit.fileId = data.data
						this.$message({
							message: this.$t('msg_15'),
							type: 'success'
						});
						this.chooseFile = true;
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			download() {
				let that=this
				if (this.allList.status == '7') {
					if (this.allList.pdfId == null) {
						malfunction.selectpdf(this.id).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.allList.pdfId = data.data
							}
						}).catch((response) => {
							console.log(response)
						})
					}
					this.timers = setInterval(() => {
						if(this.allList.pdfId!=null){
							clearInterval(that.timers);
							that.timers=null;
							window.open(this.$store.getters.getPostUrl + 'mes/sysFile/download/' + this.allList.pdfId, "_blank")
						}
					}, 1000)
				} else {
					utils.messageAlert(this.$t('msg_220'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			quick() {
				this.quickData = '1';
				this.selectknowledge();
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					file.repairTaskNum(query).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.loading = false;
							this.options = data.data;
						}
					}).catch((response) => {
						this.loading = false;
						console.log(response)
					})
				} else {
					this.options = [];
				}
			},
			remoteMethod3(query) {
				if (query !== '') {
					this.loading = true;
					file.selectUser(query).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.loading = false;
							this.options3 = data.data;
						}
					}).catch((response) => {
						this.loading = false;
						console.log(response)
					})
				} else {
					this.options3 = [];
				}
			},
			remoteMethod2(query) {
				if (query !== '') {
					this.loading = true;
					file.selectUser(query).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.loading = false;
							this.options2 = data.data;
						}
					}).catch((response) => {
						this.loading = false;
						console.log(response)
					})
				} else {
					this.options2 = [];
				}
			},
			handleClick0(tab, event) {
				if (tab.name == 'feng4') {
					let that = this;
					utils.clearTime();
					this.riskRecord();
					utils.timing(function() {
						that.riskRecord()
					}, 30000);
				}
			},
			riskRecord() {
				if (this.allList.appointMeet == 1) {
					file.riskRecord1(this.id).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.feng4Date1 = data.data[0].date;
							this.feng4Data1 = data.data[0].data;
							this.feng4Date2 = data.data[1].date;
							this.feng4Data2 = data.data[1].data;
							this.feng4Date3 = data.data[2].date;
							this.feng4Data3 = data.data[2].data;
							this.feng4Date4 = data.data[3].date;
							this.feng4Data4 = data.data[3].data;
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					file.riskRecord(this.id).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.feng4Date = data.data.date;
							this.feng4Data = data.data.data;
						}
					}).catch((response) => {
						console.log(response)
					})
				}
			},
			setMealSelect1() {
				// 截取数组的最后一位,并从新赋值
				this.checkList100 = this.checkList100.slice(-1);
				if (this.checkList100[0] == '1') {
					this.tableDataEdit.other = true;
				} else {
					this.tableDataEdit.other = false;
				}
			},
			goNew() {
				for (var i = 0; i < this.knowledgeCheckList.length; i++) {
					var add = true;
					for (var j = 0; j < this.knowledgeListNew.length; j++) {
						if (this.knowledgeListNew[j].id == this.knowledgeCheckList[i].id) {
							add = false;
						}
					}
					if (add) {
						this.knowledgeListNew.push(this.knowledgeCheckList[i])
					}
				}
				this.knowledgeCheckList = [];
			},
			selectknowledge() {
				file.getDictList2({name: this.knowledgeSelect.faultReasonClassify, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.causeList = data.data;
						this.knowledgeSelect.faultReason = this.causeList[0].val;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList2(this.knowledgeSelect.faultReasonClassify).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.causeList = data.data;
        //     this.knowledgeSelect.faultReason = this.causeList[0].val;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
				malfunction.knowledge(this.knowledgeSelect).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.knowledgeList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        file.getByDictIdALL({dictId: 9, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.cause = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(9).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.cause = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex + 1 == this.feng4Data.length && columnIndex == 0) {
					return {
						rowspan: 1,
						colspan: 2
					}
				} else if (rowIndex + 1 == this.feng4Data.length && (columnIndex < 2)) { //重点在else
					return {
						rowspan: 0, //清除就是这俩属性设置为0
						colspan: 0 //清除就是这俩属性设置为0
					}
				}
			},
			objectSpanMethod1({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex + 1 == this.feng4Data1.length && columnIndex == 0) {
					return {
						rowspan: 1,
						colspan: 2
					}
				} else if (rowIndex + 1 == this.feng4Data1.length && (columnIndex < 2)) { //重点在else
					return {
						rowspan: 0, //清除就是这俩属性设置为0
						colspan: 0 //清除就是这俩属性设置为0
					}
				}
			},
			objectSpanMethod2({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex + 1 == this.feng4Data2.length && columnIndex == 0) {
					return {
						rowspan: 1,
						colspan: 2
					}
				} else if (rowIndex + 1 == this.feng4Data2.length && (columnIndex < 2)) { //重点在else
					return {
						rowspan: 0, //清除就是这俩属性设置为0
						colspan: 0 //清除就是这俩属性设置为0
					}
				}
			},
			objectSpanMethod3({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex + 1 == this.feng4Data3.length && columnIndex == 0) {
					return {
						rowspan: 1,
						colspan: 2
					}
				} else if (rowIndex + 1 == this.feng4Data3.length && (columnIndex < 2)) { //重点在else
					return {
						rowspan: 0, //清除就是这俩属性设置为0
						colspan: 0 //清除就是这俩属性设置为0
					}
				}
			},
			objectSpanMethod4({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex + 1 == this.feng4Data4.length && columnIndex == 0) {
					return {
						rowspan: 1,
						colspan: 2
					}
				} else if (rowIndex + 1 == this.feng4Data4.length && (columnIndex < 2)) { //重点在else
					return {
						rowspan: 0, //清除就是这俩属性设置为0
						colspan: 0 //清除就是这俩属性设置为0
					}
				}
			},
			getDictList1() {
        file.getByDictIdALL({dictId: 8, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.faultList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(8).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.faultList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList2() {
        file.getByDictIdALL({dictId: 12, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.urgentList = data.data;
						this.urgentLevelStatusList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(12).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.urgentList = data.data;
        //     this.urgentLevelStatusList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList3() {
        file.getByDictIdALL({dictId: 11, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.faultPhenomenonList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(11).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.faultPhenomenonList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList4() {
				file.getDictList1(9).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.faultReasonClassifyList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getDictList6() {
        file.getByDictIdALL({dictId: 13, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkList2 = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(13).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.checkList2 = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList7() {
        file.getByDictIdALL({dictId: 14, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkList3 = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(14).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.checkList3 = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList8() {
        file.getByDictIdALL({dictId: 12, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.levelList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(12).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.levelList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList9() {
        file.getByDictIdALL({dictId: 16, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.guzhangList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(16).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.guzhangList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			selectAll() {
				malfunction.selectById(this.id).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.allList = data.data;
						let info = data.data;
						if (this.allList.appointMeet == 1) {
							this.valueOpenClose = true;
						} else {
							this.valueOpenClose = false;
						}
						//处理状态 1：待派单；2：待确认；3：待维修；4：维修中；5：待验收；6：验收中；7：已完成；8：已关闭
						let active = Number(info.status);
						if (active >= 5) {
							active--;
						}
						this.status = {
							active: active,
							reportPerson: info.reportPerson,
							reportTime: info.reportTime == undefined ? '' : info.reportTime.slice(0, 16),
							dispatcher: info.dispatcher,
							dispatchTime: info.dispatchTime == undefined ? '' : info.dispatchTime.slice(0, 16),
							receivingPerson: info.receivingPerson,
							orderTime: info.orderTime == undefined ? '' : info.orderTime.slice(0, 16),
							repairman: info.repairman,
							repairBeginTime: info.repairBeginTime == undefined ? '' : info.repairBeginTime
								.slice(0, 16),
							accepter: info.accepter,
							acceptBeginTime: info.acceptBeginTime == undefined ? '' : info.acceptBeginTime
								.slice(0, 16),
							acceptEndTime: info.acceptEndTime == undefined ? '' : info.acceptEndTime.slice(0,
								16),
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getNow() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let h = zeroTime.getHours() < 10 ? '0' + zeroTime.getHours() : zeroTime.getHours()
				let m = zeroTime.getMinutes() < 10 ? '0' + zeroTime.getMinutes() : zeroTime.getMinutes()
				let s = zeroTime.getSeconds() < 10 ? '0' + zeroTime.getSeconds() : zeroTime.getSeconds()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates + ' ' + h + ':' + m + ':' + s;
				return now;
			},
			getDifferentData(arrA, arrB) {
				return arrA.concat(arrB).filter(function(v, i, arr) {
					return arr.indexOf(v) === arr.lastIndexOf(v);
				});
			},
			selectdictList() {
        file.getByDictIdALL({dictId: 15, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.malfunctionList = data.data
          }
        }).catch((response) => {
          console.log(response)
        })
        // file.getDictList(15).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.malfunctionList = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
        file.getByDictIdALL({dictId: 16, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.maintainList = data.data
          }
        }).catch((response) => {
          console.log(response)
        })
        // file.getDictList(16).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.maintainList = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
        file.getByDictIdALL({dictId: 9, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.cause = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(9).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.cause = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
				// file.getDictList(10).then((response) => {
				// 	const data = response.data;
				// 	if (data.code == "1") {
				// 		this.causeList = data.data
				// 	}
				// }).catch((response) => {
				// 	console.log(response)
				// })
        file.getByDictIdALL({dictId: 17, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.delayedList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(17).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.delayedList = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
        file.getByDictIdALL({dictId: 18, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.productTrackList = data.data
          }
        }).catch((response) => {
          console.log(response)
        })
				// file.getDictList(18).then((response) => {
				// 	const data = response.data;
				// 	if (data.code == "1") {
				// 		this.productTrackList = data.data
				// 	}
				// }).catch((response) => {
				// 	console.log(response)
				// })
        file.getByDictIdALL({dictId: 19, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.bulkTrackList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(19).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.bulkTrackList = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},

			getLable(index) {
				if (index == 0) {
					return this.$t('label_33') + '(1' + this.$t('label_37') + ')';
				}
				return index + 1 + this.$t('label_37');
			},
			getLable1(index) {
				if (index == 0) {
					return this.$t('label_33');
				}
				return index + this.$t('label_37');
			},
			getRiskList() {
				this.riskConfrimList = [];
				let param = {
					taskId: this.receiveList.taskId
				}
				malfunction.riskConfrimListMes(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.riskConfrimList = data.data;
						this.fengModelHead = this.riskConfrimList[0].head;
						for (var key in this.riskConfrimList[0].rkList) {
							this.riskConfrimData.push(this.riskConfrimList[0].rkList[key].id);
						}
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
      exportExcel() {
        let status = [];
        for (var i = 0; i < this.spotStatusNumList.length; i++) {
          if (this.spotStatusNumList[i].check == true) {
            status.push(i)
          }
        }
        let dataParam = {
          beginTime: this.Readytime[0] + " 00:00:00",
          endTime: this.Readytime[1] + " 23:59:59",
          faultLevel: this.faultLevel,
          status: status,
          orderNo: this.orderNo,
          type: this.deviceDetailMes.type,
          id: this.deviceDetailMes.id,
        }
        malfunction.resumeExport(dataParam, this.switched).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          let link = document.createElement('a')
          link.href = url
          link.download = decodeURIComponent(response.headers['content-disposition'].split('fileName=')[1])
          link.click()
          URL.revokeObjectURL(url)
        })
      }
		},
		created() {
			// var i=0
			// this.timers = setInterval(() => {
			// 	console.log(i++);
			// }, 1000)
			this.Readytime = [this.getThreeDaysAgo(), this.getNowTime()]
			this.getRiskList1();
			this.MenuRoleList = this.$store.getters.getMenu;
			this.selectdictList();
			this.getDictList1();
			this.getDictList2();
			this.getDictList3();
			this.getDictList4();
			this.getDictList6();
			this.getDictList7();
			this.getDictList8();
			this.getDictList9();
		}
	}
</script>
<style>
	.cb .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
		border-color: #ffffff;
	}

	.cb .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
		background-color: #409EFF;
		border-color: #409EFF;
	}

	.circleStyle {
		width: 20px;
		height: 20px;
		border-radius: 20px;
		margin: 6px 0;
	}
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/malfunction/malfunctionResumePage.vue